import {GitPullRequestDraftIcon} from '@primer/octicons-react'

import {EffectiveEntryStatus} from '../../../../helpers/effective-entry-status'
import type {EffectiveEntryStatus as EffectiveEntryStatusType} from '../../../../helpers/effective-entry-status'

export function DraftStatusIcon({status}: {status: EffectiveEntryStatusType}) {
  if (status !== EffectiveEntryStatus.Draft) return null

  return <GitPullRequestDraftIcon className="color-fg-muted" aria-label="Cannot merge" />
}
